<template>
  <v-row
    no-gutters
    class="align-center element justify-space-between flex-nowrap"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
  >
    <v-col>
      <v-row no-gutters class="flex-nowrap align-center">
        <v-col cols="auto">
          <div
            class="text-truncate text-body-2 flex-shrink-0"
            :class="{ 'pl-2': level > 1, 'text--disabled': disabled }"
            style="padding-top: 2px;"
          >
            {{ title }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="auto">
      <dots-menu
        v-if="dotsItems && dotsItems.length"
        :disabled="disabled"
        font-size="19px"
        :items="dotsItems"
        v-on="getListeners()"
      />
    </v-col>
  </v-row>
</template>
<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'DraggableListItem',
  components: { DotsMenu },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    dotsItems: {
      type: Array,
    },
    childItemsKey: {
      type: String,
      default: 'items',
    },
    level: {
      type: Number,
      default: 1,
    },
    titleKey: {
      type: String,
      default: 'name',
    },
  },
  computed: {
    isGroup() {
      return this.$attrs[this.childItemsKey] ? true : false;
    },
    classes() {
      return this.level > 1 ? [`px-${this.level * 2}`, 'border'] : this.isGroup ? [] : ['px-6'];
    },
    backgroundColor() {
      return this.isGroup ? 'white' : 'rgb(231, 231, 231, 0.5)';
    },
    title() {
      return this.$attrs[this.titleKey];
    },
  },
  methods: {
    getListeners() {
      return Object.keys(this.$listeners).reduce((total, key) => {
        return {
          ...total,
          [key]: () => {
            this.$emit(key, { ...this.$props, ...this.$attrs });
          },
        };
      }, {});
    },
  },
};
</script>
<style scoped lang="scss">
.element {
  height: 40px;
}
.border {
  margin-bottom: 4px;
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
</style>
